module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_05_stay-c305d918796bb5446ad9cf2d45899ebc.jpg";